import { render, staticRenderFns } from "./survey-page.vue?vue&type=template&id=62190f3a"
import script from "./survey-page.vue?vue&type=script&lang=js"
export * from "./survey-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports